'use client';
import styled from 'styled-components';

export const StyledIncrementingStatBlock = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  width: 100%;
  min-width: 270px;
  min-height: 160px;
  padding: ${props => props.theme.spacing(7, 8)};
  border-radius: ${props => props.theme.spacing(8)};
  overflow-wrap: break-word;

  background-color: ${({ theme, $backgroundColor }) =>
    $backgroundColor
      ? theme.colors.get($backgroundColor)
      : theme.colors.background.lightest};
  color: ${({ theme, $textColor }) =>
    $textColor ? theme.colors.get($textColor) : theme.colors.text.primary};

  @media ${props => props.theme.tabletL} {
    width: 100%;
    height: 100%;
    min-height: 200px;
    max-height: 450px;
  }
`;

export const BlockHeading = styled.p`
  ${({ theme }) => theme.typography.heading2};
  background-color: ${({ theme, $backgroundColor }) =>
    $backgroundColor
      ? theme.colors.get($backgroundColor)
      : theme.colors.background.lightest};
  margin-bottom: ${props => props.theme.spacing(3)};
`;

export const DescriptionParagraph = styled.p`
  ${props => props.theme.typography.largeBody};
`;
